<template>
  <footer class="text-white py-5 text-center">
    <router-link class="text-yellow hover:text-white mr-5" to="/privacy">Privacy Policy</router-link>
    <router-link v-if="$route.path != '/'" class="text-yellow hover:text-white" to="/">Home</router-link>
  </footer>
</template>

<script>
export default {
  name: "maldenFooter"
};
</script>

<style>
</style>
